import {
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  Toolbar,
} from '@mui/x-data-grid-pro';
import SharedToolbarQuickSearchFilter from './shared-toolbar-quick-search-filter';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import FilterListOutlined from '@mui/icons-material/FilterListOutlined';
import ViewColumnOutlined from '@mui/icons-material/ViewColumnOutlined';
import type { SxProps, Theme } from '@mui/material/styles';

interface SharedToolbarProps {
  children?: React.ReactNode;
  leftPanel?: React.ReactNode;
  noColumn?: boolean;
  noFilter?: boolean;
  noQuickFilter?: boolean;
  quickFilterPlaceholder?: string;
  quickFilterDebounceMs?: number;
  primaryButtons?: React.ReactNode;
  secondaryButtons?: React.ReactNode; // icon buttons
}

export default function SharedToolbar({
  children,
  leftPanel,
  noColumn,
  noFilter,
  noQuickFilter,
  quickFilterPlaceholder,
  quickFilterDebounceMs,
  primaryButtons,
  secondaryButtons,
}: SharedToolbarProps) {
  const toolbarButtonSx: SxProps<Theme> = {
    textTransform: 'none',
    borderRadius: 0.75,
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.12)',
    fontWeight: 500,
    borderColor: (theme) =>
      theme.palette.mode === 'light'
        ? theme.palette.text.secondary
        : theme.palette.text.primary,
    color: (theme) =>
      theme.palette.mode === 'light'
        ? theme.palette.text.secondary
        : theme.palette.text.primary,
    '&:hover': {
      borderColor: (theme) => theme.palette.primary.main,
      color: (theme) => theme.palette.primary.main,
    },
  };

  return (
    <Toolbar
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 16,
      }}
    >
      <Stack flexDirection="row" gap={1.5}>
        {!noQuickFilter && (
          <SharedToolbarQuickSearchFilter
            placeholder={quickFilterPlaceholder}
            debounceMs={quickFilterDebounceMs}
          />
        )}
        {!noColumn && (
          <ColumnsPanelTrigger
            render={(props) => (
              <Button
                {...props}
                variant="outlined"
                startIcon={<ViewColumnOutlined />}
                sx={{
                  ...toolbarButtonSx,
                }}
              >
                Columns
              </Button>
            )}
          />
        )}

        {!noFilter && (
          <FilterPanelTrigger
            render={(props) => (
              <Button
                {...props}
                variant="outlined"
                startIcon={<FilterListOutlined />}
                sx={{
                  ...toolbarButtonSx,
                }}
              >
                Filter
              </Button>
            )}
          />
        )}
        {leftPanel ? leftPanel : null}
      </Stack>
      <Stack flexDirection="row" gap={1}>
        {children ? children : null}
        {secondaryButtons ? secondaryButtons : null}
        {primaryButtons ? primaryButtons : null}
      </Stack>
    </Toolbar>
  );
}
